module.exports = __webpack_public_path__ + "assets/images/industry_phase3.dc17c27d0f6523b31d4d7926c30a631e.svg";